const defaultState = {};

const mutations = {
    setMemberState(state, member) {
        Object.assign(state, member);
    },
    resetMemberState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getMemberInfo({ commit, dispatch }, memberId) {
        try {
            const { data } = await this.$rq.getMemberInfo(memberId);
            commit('setMemberState', data);
        } catch (err) {
            dispatch('resetMemberInfo');
        }
    },
    resetMemberInfo({ commit }) {
        commit('resetMemberState');
    },
};

const getters = {
    member: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
